import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencilIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5858 3.85766L10.1423 1.41368C10.0408 1.31207 9.92019 1.23146 9.78746 1.17647C9.65473 1.12148 9.51247 1.09317 9.36879 1.09317C9.22512 1.09317 9.08286 1.12148 8.95013 1.17647C8.8174 1.23146 8.69681 1.31207 8.59524 1.41368L1.85172 8.15774C1.74979 8.25901 1.66897 8.37951 1.61396 8.51225C1.55895 8.64499 1.53084 8.78733 1.53125 8.93102V11.375C1.53125 11.6651 1.64649 11.9433 1.85161 12.1484C2.05672 12.3535 2.33492 12.4688 2.625 12.4688H5.06899C5.21267 12.4691 5.35501 12.441 5.48774 12.386C5.62048 12.331 5.74098 12.2502 5.84227 12.1483L12.5858 5.40423C12.7908 5.19912 12.906 4.92097 12.906 4.63094C12.906 4.34092 12.7908 4.06277 12.5858 3.85766ZM4.97657 11.1563H2.84375V9.02344L7.4375 4.42969L9.57032 6.56251L4.97657 11.1563ZM10.5 5.63282L8.36719 3.50001L9.37016 2.49704L11.503 4.62985L10.5 5.63282Z",
		fill: "currentColor"
	})
});
export default SvgPencilIcon;
